
import { Options, Vue } from 'vue-class-component'
import { Prop, Emit } from 'vue-property-decorator'

interface AdditionalInfo {
  label: string
  value: string | number
  valueClass?: string
}

@Options({
  name: 'OverviewCard',
})
export default class OverviewCard extends Vue {
  @Prop({ required: true })
  titleMain!: string

  @Prop({ default: '' })
  titleSub!: string

  @Prop({ default: null })
  mainValue!: number | null

  @Prop({ default: '' })
  mainValueUnit!: string

  @Prop({ default: 'text-positive' })
  mainValueClass!: string

  @Prop({ default: false })
  isMinusValue!: boolean

  @Prop({ default: true })
  showMainValueSign!: boolean

  @Prop({ default: () => [] })
  additionalInfo!: AdditionalInfo[]

  @Prop({ default: false })
  showActionButton!: boolean

  @Prop({ default: 'Details' })
  actionButtonLabel!: string

  @Prop({ default: false })
  showProgressBar!: boolean

  @Prop({ default: 0 })
  progressValue!: number

  @Prop({ default: 'positive' })
  progressColor!: string

  @Emit('action-click')
  onActionClick() {
    return {}
  }
}
